<template>
	<div v-if="!data.desired" class="sub-values inline">
		<div class="sub-value">
			<div class="label">{{ data.none ? 'Nein' : 'Egal' }}</div>
		</div>
	</div>
	<SelectedItems
		v-else
		:characteristic-items="characteristicItems"
		:characteristic-type="characteristicType"
		:selected="data.desired"
		flat
	/>
</template>

<script>
import SelectedItems from "@/vue/characteristic/SelectedItems";
import {mapState} from "vuex";

export default {
	components: {SelectedItems},

	props: {
		data: {
			type: Object,
			required: true,
		},
		characteristicItems: {
			type: Array,
			required: true,
		},
		characteristicType: {
			type: Object,
			required: true,
		}
	},

	computed: {
		...mapState('meta', ['meta']),
	}
}
</script>
